import * as React from 'react';
import { Select as BaseUISelect, SelectProps } from 'baseui/select';

interface CustomSelectProps extends SelectProps {
  additionalTestId?: string;
  name?: string;
  ref?: any;
}

const Select = (props: CustomSelectProps) => {
  return (
    <BaseUISelect
      {...props}
      overrides={{
        Root: {
          props: {
            'data-gi': `select${
              props.additionalTestId !== undefined ? ' ' + props.additionalTestId : ''
            }`
          }
        },
        DropdownContainer: {
          props: { 'data-gi': 'select-option-list' }
        }
      }}
    />
  );
};
export default Select;
